<template>
    <div class="add-base-component component padding" :style="{ width: width }">
        <div class="add-base-main border">
            <p class="title padding weight">基础信息</p>
            <div class="form-box flex padding">
                <!-- <div class="choice-pic">
                    <div class="add-button border flex">
                        <i class="el-icon-plus"></i>
                    </div>
                </div> -->
                <div class="input-form">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="名称">
                            <el-input class="long" autosize size="small" v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="Type">
                            <el-select class="long" autosize v-model="form.type" size="small">
                                <el-option value="Switch" label="Switch"></el-option>
                                <el-option value="Dimmer" label="Dimmer"></el-option>
                                <el-option value="Lock" label="Lock"></el-option>
                                <el-option value="Curtain" label="Curtain"></el-option>
                                <el-option value="AirCon" label="AirCon"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="描述">
                            <el-input class="long" autosize size="small" type="textarea" v-model="form.description"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "add-base-component",
    props: {
        form:{
        },
        width: {
            type: [String, Number],
            default: "50%"
        }
    },
    model: {
        prop: "form",
        event: "update"
    },
    data() {
        return {
        };
    },
    watch: {
        form(value) {
            this.$emit("update", value);
        }
    }
};
</script>

<style lang="scss" scoped>
.add-base-component {
    width: 50%;
    .add-base-main {
        height: 250px;
        overflow-y: auto;
    }
    .form-box {
        align-items: flex-start;
    }
    .add-button {
        justify-content: center;
        width: 120px;
        height: 120px;
        border-radius: 8px;
        font-size: 32px;
        color: #ddd;
        cursor: pointer;
    }
    .long {
        width: 280px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/add/base.vue